import { fetchHelper } from '@price-point/http-helpers';
import constants from '../constants';

export default async function getNav(dispatch, state, name) {
  const nav = await fetchHelper(state.auth.token, 'GET', `/api/v1/navs/${name}`);
  dispatch({
    type: constants.actions.RECEIVE_NAV,
    nav,
  });
}
